import { __spread } from 'tslib';

/**
 * Gets cache of a storage
 * @param storage_name Storage name
 * @returns any | null
 */
function GET_CACHE(storage_name) {
    var store = localStorage.getItem(storage_name);
    if (!store) {
        store = sessionStorage.getItem(storage_name);
    }
    return store ? JSON.parse(store) : null;
}
/**
 *  Sets a cache with specified value, storage name and temporal
 * @param value Value to storage
 * @param storage_name Storage name
 * @param temp flag to know if is a temporal storage
 */
function SET_CACHE(value, storage_name, temp) {
    if (temp === void 0) { temp = false; }
    if (value) {
        var valueString = JSON.stringify(value);
        temp ? sessionStorage.setItem(storage_name, valueString) : localStorage.setItem(storage_name, valueString);
    }
    else {
        temp ? sessionStorage.removeItem(storage_name) : localStorage.removeItem(storage_name);
    }
}

/**
 * Retrive an array with key and value from an object
 * @param object Object
 * @returns any[]
 */
function OBJECT_TO_ARRAY(object) {
    return Object.keys(object).map(function (key) {
        return { key: key, value: object[key] };
    });
}
/**
 * Retrive an array with only values from an object
 * @param object Object
 * @returns any[]
 */
function OBJECT_TO_SINGLE_ARRAY(object) {
    return Object.keys(object).map(function (key) {
        return object[key];
    });
}
/**
 * Retrive an array with only values from an object
 * @param object Object
 * @returns T[]
 */
function OBJECT_TO_ARRAY_TYPE(object) {
    return Object.keys(object).map(function (key) {
        return object[key];
    });
}

/**
 * Gets all the parameters and values from actual URL
 * @returns any{}
 */
var GET_URL_ALL_PARAMETERS = function () {
    var prmStr = window.location.search.substr(1);
    return !!prmStr ? PARAM_STRING_TO_ARRAY(decodeURIComponent(prmStr.replace(/\+/g, ' '))) : {};
};
/**
 * Returns all the parameters and values given in the URL
 * @param value URL
 * @returns any{}
 */
var PARAM_STRING_TO_ARRAY = function (value) {
    var params = {};
    var prmarr = value.split('&');
    prmarr.forEach(function (paramStr) {
        var tmpArr = paramStr.split('=');
        var value = tmpArr[1];
        var name = tmpArr[0];
        var param = params[name];
        if (param) {
            if (!Array.isArray(param)) {
                param = [param];
            }
            params[name] = __spread(param, [value]);
        }
        else {
            params[name] = value;
        }
    });
    return params;
};
/**
 * Gets values of a given parameter
 * @param name parameter to find
 * @returns string
 */
var GET_URL_PARAMETER = function (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
/**
 * Returns environment, dev, qa, uat, stg from actual URL
 * @returns string
 */
var GET_URL_ENV = function () {
    var envs = ['dev', 'qa', 'uat', 'stg'];
    var host = window.location.hostname;
    var parts = host.split('.');
    var env = parts.find(function (part) { return envs.includes(part); });
    return env ? env.toLowerCase() : '';
};

/**
 * Create a random UUID
 * @returns string
 */
function CREATE_UUID() {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}

export { CREATE_UUID, GET_CACHE, GET_URL_ALL_PARAMETERS, GET_URL_ENV, GET_URL_PARAMETER, OBJECT_TO_ARRAY, OBJECT_TO_ARRAY_TYPE, OBJECT_TO_SINGLE_ARRAY, PARAM_STRING_TO_ARRAY, SET_CACHE };
//# sourceMappingURL=uikit-components-uk-utils.js.map
